<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
            <div class="block-title">
                <h2 class="content-heading">Salary Advance Requests</h2>
            </div>
        </div>

        <div class="block-content">
            <el-table
                :data="items.filter(data => !search || JSON.parse(data.metadata).names.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%">
                <el-table-column
                    label="Amount"
                    prop="amount">
                </el-table-column>
                <el-table-column
                    label="MSIDN"
                    prop="msisdn">
                </el-table-column>
                <el-table-column
                    label="ID number"
                    prop="id_number">
                </el-table-column>
                <el-table-column
                    label="Employee Number"
                    prop="metadata">
                    <template slot-scope="scope">
                        {{ getSafe(() => JSON.parse(scope.row.metadata).employee_number ) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="Employee Name"
                    prop="metadata">
                    <template slot-scope="scope">
                        {{ getSafe(() => JSON.parse(scope.row.metadata).names ) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="Employee Position"
                    prop="metadata">
                    <template slot-scope="scope">
                        {{ getSafe(() => JSON.parse(scope.row.metadata).position ) }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="right" :width="250">
                    <template slot="header" slot-scope="scope">
                        <el-input
                            v-model="search"
                            size="mini"
                            placeholder="Type to search Name"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            type="success"
                            @click="confirmDialog('disburse',scope.$index, scope.row)">Disburse
                        </el-button>
                        <el-button
                            size="mini"
                            @click="editDialog(scope.$index, scope.row)">Edit
                        </el-button>
                        <el-button
                            size="mini"
                            type="warning"
                            @click="confirmDialog('revoke', scope.$index, scope.row)">Reject
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="Edit Disbursement Amount" :visible.sync="dialogFormVisible">
                <el-form :model="form" :label-position="labelPosition">
                    <el-form-item label="Edit Requested Amount" :label-width="formLabelWidth">
                        <el-input v-model.number="form.amount" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="editDisbursement(item_index, item_row)">Confirm</el-button>
              </span>
            </el-dialog>

            <el-dialog
                title="Confirm"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose">
                <span v-if="action==='disburse'">Are you sure you want to disburse this Loan?</span>
                <span v-if="action==='revoke'">Are you sure you want to revoke this Loan?</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">Cancel</el-button>
                    <el-button v-if="action==='disburse'" type="primary"
                               @click="beginDisbursement(item_index, item_row)">Confirm</el-button>
                    <el-button v-if="action==='revoke'" type="primary"
                               @click="revokeDisbursement(item_index, item_row)">Confirm</el-button>
              </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import {Loading} from 'element-ui';
    import {Message} from 'element-ui';

    export default {
        name: "SalaryAdvanceRequests",
        data: function () {
            return {
                employee_number: '',
                name: '',
                position: '',
                amount: '',
                msisdn: '',
                id_number: '',
                items: [],
                search: '',
                item_index: '',
                item_row: '',
                dialogVisible: false,
                dialogFormVisible: false,
                formLabelWidth: '120px',
                labelPosition: 'top',
                action: '',
                form: {
                    amount: '',
                }
            }
        },
        mounted() {
            var app = this;
            this.getRequests();
        },
        methods: {
            beginDisbursement(index, row) {
                console.log(index, row);
                console.log("Row " + JSON.stringify(row.id_number));
                console.log("Index " + JSON.stringify(row));

                var app = this;
                app.dialogVisible = false;
                let formData = new FormData();
                let item = row;
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('employee_number', JSON.parse(item.metadata).employee_number);
                formData.append('name', item.name);
                formData.append('position', item.position);
                formData.append('amount', item.amount);
                formData.append('msisdn', item.msisdn);
                formData.append('id_number', item.id_number);
                formData.append('project', this.$route.params.project);
                formData.append('senti_profile_id', item.profile_id);
                formData.append('senti_partner_id', item.partner_id);

                console.log("name " + item.name);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/apply_loan`,
                    formData
                )
                    .then(function (resp) {
                        console.log('SUCCESS!!');
                        console.log('Response!!' + JSON.stringify(resp.data.data));
                        loadingInstance.close();
                        if (JSON.parse(resp.data.data).status != 200)
                            Message.warning(JSON.parse(resp.data.data).reason);
                        else {
                            Message.success(JSON.parse(resp.data.data).reason);
                            app.getRequests()
                        }
                    }).catch(error => {
                        loadingInstance.close();
                        console.log(error.response);
                        console.log("ERROR Response " + JSON.stringify(error.response));
                        console.log("Status Response " + error.response.data.message);
                        Message.error(error.response.data.message);
                    })
                    .catch(function (resp) {
                        loadingInstance.close();
                        console.log('FAILURE!!');
                        console.log("FAILURE Response " + JSON.stringify(resp));
                        Message.error(resp.data);
                    });
            },


            editDialog(index, row) {
                var app = this;
                app.dialogFormVisible = true;

                app.item_index = index;
                app.item_row = row;
            },


            confirmDialog(action, index, row) {
                var app = this;
                app.dialogVisible = true;

                app.item_index = index;
                app.item_row = row;
                app.action = action;
            },


            editDisbursement(index, row) {
                console.log(index, row);
                console.log("Row " + JSON.stringify(row.id_number));
                console.log("Index " + JSON.stringify(row));

                var app = this;
                app.dialogFormVisible = false;
                let formData = new FormData();
                let item = row;
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('employee_number', JSON.parse(item.metadata).employee_number);
                formData.append('name', item.name);
                formData.append('position', item.position);
                formData.append('amount', app.form.amount);
                formData.append('msisdn', item.msisdn);
                formData.append('id_number', item.id_number);
                formData.append('project', this.$route.params.project);
                formData.append('senti_profile_id', item.profile_id);
                formData.append('senti_partner_id', item.partner_id);

                console.log("name " + item.name);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/edit_disbursement`,
                    formData
                )
                    .then(function (resp) {
                        console.log('SUCCESS!!');
                        console.log('Response!!' + JSON.stringify(resp.data.data));
                        loadingInstance.close();
                        if (JSON.parse(resp.data.data).status != 200)
                            Message.warning(JSON.parse(resp.data.data).reason);
                        else {
                            Message.success(JSON.parse(resp.data.data).reason);
                            app.getRequests()
                        }
                    }).catch(error => {
                        loadingInstance.close();
                        console.log(error.response);
                        console.log("ERROR Response " + JSON.stringify(error.response));
                        console.log("Status Response " + error.response.data.message);
                        Message.error(error.response.data.message);
                    })
                    .catch(function (resp) {
                        loadingInstance.close();
                        console.log('FAILURE!!');
                        console.log("FAILURE Response " + JSON.stringify(resp));
                        Message.error(resp.data);
                    });
            },


            revokeDisbursement(index, row) {
                console.log(index, row);
                console.log("Row " + JSON.stringify(row.id_number));
                console.log("Index " + JSON.stringify(row));

                var app = this;
                app.dialogVisible = false;
                let formData = new FormData();
                let item = row;
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('employee_number', JSON.parse(item.metadata).employee_number);
                formData.append('name', item.name);
                formData.append('position', item.position);
                formData.append('amount', item.amount);
                formData.append('msisdn', item.msisdn);
                formData.append('id_number', item.id_number);
                formData.append('project', this.$route.params.project);
                formData.append('senti_profile_id', item.profile_id);
                formData.append('senti_partner_id', item.partner_id);

                console.log("name " + item.name);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/delete_disbursement`,
                    formData
                )
                    .then(function (resp) {
                        console.log('SUCCESS!!');
                        console.log('Response!!' + JSON.stringify(resp.data.data));
                        loadingInstance.close();
                        if (JSON.parse(resp.data.data).status != 200)
                            Message.warning(JSON.parse(resp.data.data).reason);
                        else {
                            Message.success(JSON.parse(resp.data.data).reason);
                            app.getRequests()
                        }
                    }).catch(error => {
                        loadingInstance.close();
                        console.log(error.response);
                        console.log("ERROR Response " + JSON.stringify(error.response));
                        console.log("Status Response " + error.response.data.message);
                        Message.error(error.response.data.message);
                    })
                    .catch(function (resp) {
                        loadingInstance.close();
                        console.log('FAILURE!!');
                        console.log("FAILURE Response " + JSON.stringify(resp));
                        Message.error(resp.data);
                    });
            },


            getRequests() {
                var app = this;
                let formData = new FormData();
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('project', this.$route.params.project);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/get_requests`,
                    formData
                )
                    .then(function (resp) {
                        console.log('SUCCESS!!');
                        console.log('Response!!' + JSON.stringify(resp.data.data));
                        loadingInstance.close();
                        app.items = app.getSafe(() => resp.data.data);
                        Message.success("Salary Advance Requests Fetched")
                    }).catch(error => {
                        console.log(error.response);
                        console.log("Status Response " + error.response.data.message);
                        Message.error(error.response.data.message);
                        loadingInstance.close();
                    })
                    .catch(function (resp) {
                        console.log('FAILURE!!');
                        loadingInstance.close();
                    });
            },


            handleClose(done) {
                this.$confirm('Are you sure to close this dialog?')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            },


            getSafe(fn) {
                try {
                    return fn();
                } catch (e) {
                    return undefined;
                }
            }
        }
    }
</script>

<style scoped>

</style>
